import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import {
  NotificationOfEmergencyStageFormComponent
} from '../notification-of-emergency-stage-form/notification-of-emergency-stage-form.component';
import {
  StageFormComponent
} from '../../../../../common/occupation-data-section/components/stage-form/stage-form.component';
import {
  NotificationOfEmergencyOccupationForm,
  NotificationOfEmergencyOccupationFormValue
} from '../../forms/notification-of-emergency-occupation.form';

@Component({
  selector: 'app-notification-of-emergency-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    TabPanelComponent,
    TabViewComponent,
    NotificationOfEmergencyStageFormComponent,
    StageFormComponent
  ],
  templateUrl: './notification-of-emergency-occupation-form.component.html'
})
export class NotificationOfEmergencyOccupationFormComponent {
  @Input()
  public edit: boolean = false;

  @Input()
  public showCancel: boolean = true;

  @Input()
  public form: NotificationOfEmergencyOccupationForm | undefined;

  @Output()
  public onSubmit = new EventEmitter<NotificationOfEmergencyOccupationFormValue>();

  @Output()
  public onCancel = new EventEmitter();

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.values);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset();
  }
}
